export interface CouncilResponse {
  provider: string;
  content: string;
}

const NO_TEXT_RESPONSE = '(No text response)';
const MODEL_NAME_PREFIX_REGEX = /^\[Model:[^\]]*]/;
const UNKNOWN_PROVIDER = 'Unknown Provider';

/**
 * Parse the CouncilTool response emitted by council_tool.py.
 *
 * Each model response is wrapped in a pseudo-XML element. The body may contain
 * markdown or XML-like text, so use regex extraction instead of DOMParser.
 * The backend prepends the concrete model name for traceability; omit that
 * implementation detail from the user-facing detail view.
 */
export function parseCouncilToolResponse(rawResponse: string): Array<CouncilResponse> {
  const responses: Array<CouncilResponse> = [];
  const responseRegex = /<council_response(?:\s+provider="([^"]*)")?\s*>([\s\S]*?)<\/council_response>/g;

  for (const match of rawResponse.matchAll(responseRegex)) {
    const provider = match[1]?.trim() || UNKNOWN_PROVIDER;
    const content = match[2].trim().replace(MODEL_NAME_PREFIX_REGEX, '').trim();
    if (content) {
      if (content === NO_TEXT_RESPONSE) {
        continue;
      }
      responses.push({provider, content});
    }
  }

  return responses;
}
